import {
  FETCH_USERS_LOADING,
  FETCH_USERS_SUCCESS,
  FETCH_USERS_FAILED,
} from '../actions/usersActions';

const initialValue = {
  loading: false,
  users: [],
};

export default function (state = initialValue, action) {
  switch (action.type) {
    case FETCH_USERS_LOADING:
      return { ...state, loading: true };
    case FETCH_USERS_SUCCESS:
      return { ...state, loading: false, users: action.payload };
    case FETCH_USERS_FAILED:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export const getUsers = state => state.users.users;
export const getUsersStatus = state => state.users.loading;
export const getUsersError = state => state.users.error;
